import { render, staticRenderFns } from "./WorkoutsList.vue?vue&type=template&id=510c1d10&scoped=true&"
import script from "./WorkoutsList.vue?vue&type=script&lang=js&"
export * from "./WorkoutsList.vue?vue&type=script&lang=js&"
import style0 from "./WorkoutsList.vue?vue&type=style&index=0&id=510c1d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510c1d10",
  null
  
)

export default component.exports